import { createAction } from 'redux-actions';

export const ListBoxRequest         = createAction('LIST_BOX_REQUEST');
export const ListBoxSuccess         = createAction('LIST_BOX_SUCCESS');
export const ListBoxFailed          = createAction('LIST_BOX_FAILED');
export const ListBoxClear           = createAction('LIST_BOX_CLEAR');